var _path, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 536 536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h535.547v535.547H0z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h535.547v535.547H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M535.547 40a40 40 0 00-40-40H40a39.996 39.996 0 00-28.284 11.716A39.996 39.996 0 000 40v455.547a40 40 0 0040 40h455.547a40.003 40.003 0 0028.285-11.715 40.003 40.003 0 0011.715-28.285V40zM159.161 200.953H79.876v254.979h79.285V200.953zm126.359 36.318c15.347-24.858 42.704-42.646 77.092-42.646 77.441 0 94.697 54.503 94.697 113.74v147.567h-79.285V321.43c0-30.987-9.114-56.857-43.355-56.857-27.335 0-46.356 22.041-46.356 56.857v134.502h-79.285V200.953h76.492v36.318zM119.518 74.954c24.889 0 45.096 20.207 45.096 45.096 0 24.889-20.207 45.095-45.096 45.095-24.889 0-45.095-20.206-45.095-45.095s20.206-45.096 45.095-45.096z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.630cb62a9dbec257d75656412b6077ea.svg";
export { ForwardRef as ReactComponent };